import { FieldSchema, FieldValueObject, isEmpty, EMPTY_VALUE } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";
import { getVariants } from "../external-sources/CategoryMappings";
import { SchemaContext } from "../../common";
import { Modes } from "./mode";

export const createVariant = (context: SchemaContext): FieldSchema => ({
  grid: {
    displayed: true,
    order: 41,
    filter: GridFilterTypes.SET,
    // Set filter without a `data` enum: assigned through the MasterDataPicker, so the options
    // are grid-scoped. Equipment mappings only — clusters carry no variant of their own here.
    filterValues: { getter: () => getVariants(context.client) },
  },
  name: "variant",
  data: {
    assignedValue: {
      getter: ({ variant, masterDataPicker, mode }) => {
        // See `equipmentCategory`: in a CSV the column wins over the picker rebuilt from
        // the stored record.
        if (masterDataPicker && mode !== Modes.CSV) {
          return (masterDataPicker as FieldValueObject)?.variant ?? EMPTY_VALUE;
        }
        return isEmpty(variant) ? EMPTY_VALUE : variant;
      },
      fields: ["masterDataPicker", "mode"],
    },
  },
  display: {
    displayed: true,
  },
  form: { label: "Variant" },
});
